import { MethodBaseOptions } from "@zaprooecommerce/magento-sdk/lib/types";
import { type UseChallengeV3Return } from "vue-recaptcha";
import { useRecaptchaDisplayControl } from "~/modules/recaptcha/composables/useRecaptchaDisplayControl";

declare global {
  // @ts-ignore
  function useRecaptchaProvider(): void;
  // @ts-ignore
  function useChallengeV3(action: string): UseChallengeV3Return;
}

export function useRecaptcha(action = "submit") {
  const {
    public: { recaptchaIsEnabled },
  } = useRuntimeConfig();
  const getToken = ref<() => Promise<string> | undefined>();
  const countOfInstances = useState<number>(
    "recaptcha-count-instances",
    () => 0,
  );
  const { updateRecaptchaDisplay, checkMountedRecaptcha } =
    useRecaptchaDisplayControl();

  async function prepareMagentoSdkOptionsWithRecaptcha(
    options?: MethodBaseOptions,
  ): Promise<MethodBaseOptions | undefined> {
    if (!recaptchaIsEnabled || !getToken.value) {
      return options;
    }

    const response = await getToken.value();

    if (!response) {
      return options;
    }

    return {
      ...options,
      customHeaders: {
        ...options?.customHeaders,
        "X-ReCaptcha": response,
      },
    };
  }

  onUnmounted(() => {
    if (recaptchaIsEnabled && --countOfInstances.value === 0) {
      updateRecaptchaDisplay();
    }
  });

  onMounted(() => {
    if (recaptchaIsEnabled) {
      if (!countOfInstances.value && !checkMountedRecaptcha()) {
        useRecaptchaProvider();
      }

      const { execute } = useChallengeV3(action);
      getToken.value = execute;

      if (++countOfInstances.value === 1) {
        updateRecaptchaDisplay();
      }
    }
  });

  return {
    prepareMagentoSdkOptionsWithRecaptcha,
  };
}
